import { render, staticRenderFns } from "./VendorSearch_List.vue?vue&type=template&id=2f565d91&"
import script from "./VendorSearch_List.vue?vue&type=script&lang=js&"
export * from "./VendorSearch_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports